import "./_title-text-3-columns-tiles-styles.scss";

import './title-text-3-columns-tiles';
